import React from 'react';
type SectionHeadingProps = {
  title: string;
  subtitle?: React.ReactNode;
  id?: string;
};
export function SectionHeading({
  title,
  subtitle,
  id
}: SectionHeadingProps) {
  return <div className="text-center" data-id="element-69" data-mp="3f1c440gibp0y">
      <h2 id={id} className="mx-auto max-w-2xl font-display text-2xl font-extrabold uppercase leading-tight text-white md:text-[2rem]" data-id="element-70" data-mp="3f2dqv26vxzyi">{title}</h2>
      <div className="mx-auto mt-4 h-1 w-14 rounded-full bg-cyan-500" aria-hidden="true" data-id="element-71" data-mp="3k201r4z8r445" />
      {subtitle && <div className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-72" data-mp="gjgk0we6vgnl">{subtitle}</div>}
    </div>;
}